import api from "../index";

// Check if the user is marketing admin
export const currentMarketingAdmin = async () => {
  return await api.post("/currentMarketingAdmin", {});
};
